import instance from "../instance";

import posts from "./posts";
import departments from "./departments";
import regions from "./regions";
import search from "./search";

export default {
  posts: posts(instance),
  departments: departments(instance),
  regions: regions(instance),
  search: search(instance),
};
